/* Process steps (sections/process-steps.liquid).

   Every index row and every "Next step" is a real anchor to its card, so
   they work with JavaScript off. This only upgrades them: the click scrolls
   smoothly and the index marks the target at once, and an observer reading
   a band across the middle of the viewport keeps the mark on whichever card
   you are reading. Between the ends nothing is in the band, so the last
   answer stands rather than the index going blank. */
if (!customElements.get('oorla-process')) {
  class OorlaProcess extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-step]'));
      this.links = Array.from(this.querySelectorAll('[data-step-link]'));
      this.inBand = new Set();
      if (!this.cards.length) return;

      this.onClick = (event) => {
        const link = event.target.closest('[data-step-target]');
        if (!link || !this.contains(link)) return;
        const index = Number(link.dataset.stepTarget);
        const card = this.cards[index];
        if (!card) return;
        event.preventDefault();
        /* Swipe mode on a phone: the steps are a running carousel, so the
           link moves it to that step rather than scrolling the page. */
        const carousel = card.closest('splide-carousel');
        const slider = carousel && carousel.slideInstance;
        if (slider && slider.root.classList.contains('is-active')) {
          slider.go(index);
          this.mark(index);
          return;
        }
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        card.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        this.mark(index);
      };
      this.addEventListener('click', this.onClick);

      if (!this.links.length || typeof IntersectionObserver === 'undefined') return;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const index = this.cards.indexOf(entry.target);
            if (index < 0) return;
            if (entry.isIntersecting) this.inBand.add(index);
            else this.inBand.delete(index);
          });
          if (this.inBand.size) this.mark(Math.min(...this.inBand));
        },
        { rootMargin: '-40% 0px -40% 0px', threshold: 0 }
      );
      this.cards.forEach((card) => this.observer.observe(card));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.observer) this.observer.disconnect();
      if (this.inBand) this.inBand.clear();
    }

    mark(index) {
      this.links.forEach((link) => {
        if (Number(link.dataset.stepLink) === index) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }
  }

  customElements.define('oorla-process', OorlaProcess);
}
